module.exports = __webpack_public_path__ + "img/grid-3x3.1018b99a.svg";